export default __webpack_public_path__ + "static/media/night-cloud.984891b3.svg";